import {BMTheme} from "../../../BMTheme";

export const listStyle = {
  cardActionStyle: {
    zIndex: 2,
    display: "inline-block",
    float: "right",

    iconStyle: {
      justifyContent: "flex-end",
      alignItems: "flex-end",
      marginBottom: "-25%"
    }
  },

  textFieldContainer: {
    display: "flex",
    alignItems: "center"
  },
  avatarSyle: {
    fontSize: "1.2em"
  },
  textFieldStyle: {
    paddingLeft: "5%",
    flex: 1
  },
  booleanFieldStyle: {
    margin: 0
  }
};

export const formStyle = {
  titleStyle: {
    textTransform: "capitalize"
  },
  containerInput: {
    marginRight: "2%"
  },
  validationStyle: {
    color: BMTheme.formValidation.color,
    fontSize: "80%"
  }
};

export const viewStyle = {
  textFieldStyle: {
    textTransform: "capitalize"
  },
  dialogAction: {
    display: "flex",
    justifyContent: "space-between",
    paddingBottom: 10,
    paddingTop: 10,
    paddingLeft: 30,
    paddingRight: 30
  },
  raisedButton: {
    marginTop: "2%"
  },
  raisedButtonProgress: {
    marginTop: "0.2em"
  },
  raisedButtonLabel: {
    color: BMTheme.palette.alternateTextColor
  },
  booleanFieldStyle: {
    margin: 0
  }
};



// WEBPACK FOOTER //
// ./src/containers/CRM/StoreMessages/style.js